import React from "react";
import BootstrapTable from "react-bootstrap-table-next";

import { dateFormat, priceFormat } from "utils/format";
import { Cut } from "components/Cut";
import { StatusOrderToProvider } from "components/StatusOrderToProvider";

import user from "assets/img/user.svg";

import "./returnRequestsTable.scss";

export const ReturnRequestsTable = ({ returnRequests, rowEvents, statusHandler, statuses }) => {
  const tableColumns = [
    {
      dataField: "number",
      text: "№",
      formatter: (cell, row) => row.returnRequest.number,
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "date",
      text: "Дата возврата",
      formatter: (cell, row) => dateFormat(row.returnRequest.date),
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "customer",
      text: "Клиент",
      formatter: (cell, row) => row.customer.name,
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "admin",
      text: "Автор",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => (
        <Cut>
          <span className="user-cell">
            <img src={user} alt="user" />
            {row.admin.name}
          </span>
        </Cut>
      ),
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: () => {
        return { width: "4%" };
      },
      headerClasses: () => "right",
      classes: () => "right bold",
    },
    {
      dataField: "summ",
      text: "Сумма",
      headerStyle: () => {
        return { width: "4%" };
      },
      formatter: (cell, row) => priceFormat(row.returnRequest?.sum),
      headerClasses: () => "right",
      classes: () => "right bold",
    },
    {
      dataField: "comment",
      text: "Комментарий",
      headerStyle: () => {
        return { width: "9%" };
      },
      formatter: (cell, row) => <Cut>{row.returnRequest?.comment}</Cut>,
    },
    {
      dataField: "status",
      text: "Статус",
      headerStyle: () => {
        return { width: "8%" };
      },
      formatter: (cell, row) => row.status.id ? (
        <StatusOrderToProvider
          status={{
            color: row.status.color,
          }}
          statuses={statuses}
          statusHandler={(status) => statusHandler(row.id, status)}
        >
          {row.status.name}
        </StatusOrderToProvider>
      ) : null,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          e.stopPropagation();
        },
      },
    },
  ];

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={returnRequests}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        hover={true}
        classes="pointer"
        rowEvents={rowEvents}
      />
    </>
  );
};
